
      import FollowFilled from './follow-filled.vue'
      import type { App, Plugin } from 'vue'

      export const FollowFilledPlugin: Plugin = {
        install(app: App) {
          app.component('FollowFilled', FollowFilled)
        },
      }
      export { FollowFilled }
      